var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -776 592 592",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.23-308h32v-248h-32zM464-308h32v-344h-32zm146.77 0h32v-104h-32zM240.62-184q-24.32 0-40.47-16.15T184-240.62v-478.76q0-24.32 16.15-40.47T240.62-776h478.76q24.32 0 40.47 16.15T776-719.38v478.76q0 24.32-16.15 40.47T719.38-184zm0-32h478.76q9.24 0 16.93-7.69t7.69-16.93v-478.76q0-9.24-7.69-16.93T719.38-744H240.62q-9.24 0-16.93 7.69T216-719.38v478.76q0 9.24 7.69 16.93t16.93 7.69M216-744v528z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertChart);
export default __webpack_public_path__ + "static/media/insert_chart.c4f1d6c9d2007886f450bfa75ff6b030.svg";
export { ForwardRef as ReactComponent };